// extracted by mini-css-extract-plugin
export default {"map":"DeliverySettings_map__zvcu-","label":"DeliverySettings_label__YKFF2","saveBtnWrapper":"DeliverySettings_saveBtnWrapper__KPdG5"};